import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusPill } from "@/components/PageHeader";
import { money } from "@/lib/api";

const dayKey = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "2-digit", month: "2-digit", year: "numeric" });

const SaleRow = ({ x, onOpen, onPdf }) => {
  const order = x.type === "order";
  return (
    <div className="row-hover flex cursor-pointer flex-col gap-2 border-t border-slate-100 px-4 py-3.5 sm:flex-row sm:items-start sm:justify-between sm:gap-4 sm:px-5" onClick={() => onOpen(x)} data-testid={`quote-row-${x.number}`}>
      <div className="min-w-0">
        <div className="truncate font-semibold text-[#0B1523]">{x.customer?.name}</div>
        <div className="mt-0.5 flex flex-wrap items-center gap-2 text-xs text-slate-500">
          <span className="num">ID: {order ? x.order_number : x.number}</span>
          {order && <span className="num text-slate-400">from {x.number}</span>}
          {x.reference && <span>· {x.reference}</span>}
          <span>· {x.prepared_by}</span>
        </div>
      </div>
      <div className="flex shrink-0 items-center justify-between gap-3 sm:justify-end">
        <div className="text-right">
          <div className={`text-xs font-bold uppercase tracking-wider ${order ? "text-[#01195D]" : "text-[#1BA3E0]"}`} data-testid={`quote-type-${x.number}`}>{order ? "Order" : "Quote"}</div>
          <div className="num mt-0.5 font-medium">{money(x.total)}</div>
        </div>
        <StatusPill status={x.status} />
        <Button size="sm" variant="ghost" onClick={(e) => onPdf(e, x)} data-testid={`quote-pdf-btn-${x.number}`}><Download className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};

export const SalesList = ({ quotes, onOpen, onPdf }) => {
  const groups = [];
  quotes.forEach((x) => {
    const k = dayKey(x.created_at);
    if (!groups.length || groups[groups.length - 1].k !== k) groups.push({ k, rows: [] });
    groups[groups.length - 1].rows.push(x);
  });
  if (!quotes.length) return <div className="px-4 py-16 text-center text-slate-500" data-testid="quotes-empty">No sales yet. Create your first quote.</div>;
  return (
    <div data-testid="quotes-table">
      {groups.map((g) => (
        <section key={g.k} className="border-b border-slate-200 last:border-b-0">
          <div className="bg-slate-50 px-5 py-2 text-xs font-semibold tracking-wider text-slate-500">{g.k}</div>
          {g.rows.map((x) => <SaleRow key={x.id} x={x} onOpen={onOpen} onPdf={onPdf} />)}
          <div className="flex justify-end gap-6 border-t border-slate-100 bg-slate-50/60 px-5 py-2.5 text-sm">
            <span className="text-slate-500">{g.rows.length} sale{g.rows.length > 1 ? "s" : ""}</span>
            <span className="font-bold text-[#01195D]">Total: <span className="num">{money(g.rows.reduce((s, x) => s + x.total, 0))}</span></span>
          </div>
        </section>
      ))}
    </div>
  );
};
